/**
Example integrate with i18next
  - lazy loading in src/component/pages: addResourceBundle({namespace})
    .e.g: addResourceBundle('newOrder')


  - add to bundle
    .e.g:
       import i18next from '@/plugins/i18next'
       import NS_vi from "@/locales2/vi/newOrder.json"
       import NS_en from "@/locales2/en/newOrder.json"

       i18next.addResourceBundle('vi', 'common', NS_vi, true);
       i18next.addResourceBundle('en', 'common', NS_en, true);

  - other single file component: <i18n><i18n>
    .e.g:
        <i18n src="./myLang.json"></i18n>

        or

        <i18n>
          {
            "en": {
              "hello": "hello world!"
            },
            "vi": {
              "hello": "xin chao"
            }
          }
        </i18n>

    more detail: https://github.com/intlify/vue-i18n-loader
*/

import i18next from 'i18next'
// import i18nextMissingKeyHandler from '@/utils/i18nextMissingKeyHandler'

import commonNS_vi from '@/locales2/vi/common.json'
import commonNS_en from '@/locales2/en/common.json'
import pickupDropoff_vi from '@/locales2/vi/pickupDropoff.json'
import pickupDropoff_en from '@/locales2/en/pickupDropoff.json'

import { DEFAULT_LOCATE } from '@/mixins/constants'

i18next
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      vi: { fallback: {}, common: commonNS_vi },
      en: { fallback: {}, common: commonNS_en }
    },
    lng: 'vi',
    fallbackLng: DEFAULT_LOCATE,
    debug: false,
    load: 'languageOnly',
    ns: ['fallback', 'common'],
    defaultNS: 'fallback',
    fallbackNS: ['fallback', 'common'],
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}'
    },
    saveMissing: true,
    saveMissingTo: 'current'
  })

i18next.addResourceBundle('vi', 'common', pickupDropoff_vi, true)
i18next.addResourceBundle('en', 'common', pickupDropoff_en, true)

// fetching missing key
// i18next.on('missingKey', i18nextMissingKeyHandler(i18next))

// export const addResourceBundle = async (resName) => {
//   // add language resource file to 'common' namespace
//   // due to we only use 'common' namespace as default
//
//   import(`@/locales2/vi/${resName}.json`).then(data => {
//     i18next.addResourceBundle('vi', 'common', data, true);
//   })
//   import(`@/locales2/en/${resName}.json`).then(data => {
//     i18next.addResourceBundle('en', 'common', data, true);
//   })
// }

export default i18next
